import React, { Component } from 'react';

class HorizontalLine extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <hr 
                className={this.props.className}
            />        
        )
    }
}
HorizontalLine.propTypes = {
    className: React.propTypes.node,
}
export default HorizontalLine;